// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/body/frontPage.styl
// module id = 423
// module chunks = 0